import type { SearchFilterInstance } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/searchFilterInstance";
import countryService from "app/services/CountryService";
import { WORLDWIDE_COUNTRY_ID } from "app/services/countryServiceConst";

import AppIosDownloadEngagementFilter from "../../components/filters/AppDownloadEngagementFilter/ios/AppIosDownloadAndEngagementFilter";
import AppIosDownloadEngagementFilterResult from "../../components/filters/AppDownloadEngagementFilter/ios/AppIosDownloadAndEngagementFilterResult";
import type { IFindAppsDescriptionDto } from "../../types/descriptionDto";
import { appsFilterCategoryMap } from "../../types/filterCategory";

import FindIosDownloadAndEngagementFilter from "./IosDownloadAndEngagementFilter";

const createIosDownloadAndEngagementFilter = (description: IFindAppsDescriptionDto): SearchFilterInstance => {
    const countries = countryService.getCountriesByIds(description.androidDownloadsAndEngagement.supportedCountries);
    return {
        key: "downloadsAndEngagement",
        trackingName: "App Downloads and Engagement",
        apiCategory: "appsFilters",
        category: appsFilterCategoryMap.apps,
        visibility: "always-visible",
        title: { key: "si.find_apps.filters.ios-download-and-engagement.title" },
        tooltipText: { key: "si.find_apps.filters.ios-download-and-engagement.tooltip" },
        filter: new FindIosDownloadAndEngagementFilter({
            options: description.iosDownloadsAndEngagement,
            initialDtoValue: {
                country: WORLDWIDE_COUNTRY_ID,
            },
            countries,
        }),
        filterView: AppIosDownloadEngagementFilter,
        filterResultView: AppIosDownloadEngagementFilterResult,
    };
};

export default createIosDownloadAndEngagementFilter;
